import { IoClose } from "react-icons/io5";
import EventCard from "../AdminDashboardPage/EventCard[1]";
import ConclaveEventCard from "./ConclaveEvenrCard";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NoDataContent } from "../../components/EmptyDataComponent/NoDataContent";


const ConcaveList = [

    {
        type: 'Engineering College (Government)',
        district: 'Kozhikode',
        name: 'Government Engineering College Kozhikode',
        duration: 'One Day',
        date: '25/7/2024',
    },
    {
        type: 'Engineering College (Self financing)',
        district: 'Thrissur',
        name: 'Christ College of Engineering',
        duration: '3 Hours',
        date: '26/7/2024',
    },
    {
        type: 'Engineering College (Government)',
        district: 'Kottayam',
        name: 'Rajiv Gandhi Institute of Technology',
        duration: 'Three Days',
        date: '26/7/2024',
    },
    {
        type: 'Engineering College (Aided)',
        district: 'Kottayam',
        name: 'TKM COLLEGE OF ENGINEERING, KARICODE',
        duration: 'Three Days',
        date: '26/7/2024',
    },

    
]

export const DisplayConclaveEventList = ({ handleClose, selectedSDG, sdgName}) => {

    const navigate = useNavigate();

    const [eventList, setEventList] = useState([]);

    const userData = JSON.parse(window.localStorage.getItem('token'));
    const token = userData ? userData.token : null;

    const fetchEventList = async () => {

        try {

            const urlParams = new URLSearchParams();

            urlParams.set('sdg', selectedSDG);

            const response = await fetch(
              `${process.env.REACT_APP_SERVER_BASE_URL + `/api/preconclaveevents/getall?${urlParams.toString()}`}`,
              {
                method: "GET",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
  
            if (response.status === 401) {
              alert("Session Expired, Please login again");
              localStorage.removeItem("token");
              navigate("/login");
            }
  
            if (response.status === 403) {
              alert("Your are not authorized to access this page");
              throw new Error("Non-Authorized Route Access Error");
            }
  
            if (!response.ok) {
              throw new Error("Failed to fetch data");
            }
  
            const jsonData = await response.json();
            console.log(jsonData, "FROM EVENT LIST");
            setEventList(jsonData);
  
          } catch (error) {
            console.error("Error fetching data:", error);
          }
    }

    useEffect( () => {

        if (!selectedSDG) {
            return;
        }

        fetchEventList();

    }, [selectedSDG])

    const navigateToPreConclave = () => {

        navigate(`/pre-conclave/${selectedSDG}`);
    }

    console.log(ConcaveList);
    return (
        <div
            className=" relative p-4 w-full  max-w-4xl bg-slate-100  shadow rounded overflow-y-auto animate-zoom-in"
        >   
            <button
                onClick={handleClose}
                className=" absolute right-3 top-3 w-10 h-10 flex justify-center items-center hover:bg-gray-400 opacity-40 duration-300 rounded-full"
            >
                <IoClose size={24} />
            </button>
            <div
                className=" w-full  z-20"
            >
                <h1 className=" text-xl font-semibold">{selectedSDG}</h1>
                <h1 className=" text-lg font-semibold mt-6">PRECONCLAVE EVENT LIST</h1>
            </div>
            {eventList && eventList.length > 0 ? <div
                className=" w-full  mt-4 "
            >   
                {eventList.map( (eachConclave, index) => (
                    <ConclaveEventCard
                        key={index}
                        details={eachConclave.description}
                        name={eachConclave.name}
                        district={eachConclave.location}
                        time={eachConclave.time}
                        date={eachConclave.date.slice(0, 10)} 
                        handleViewGallery={navigateToPreConclave}
                        youtubeLink={eachConclave.videos.length > 0 ? eachConclave.videos[0].url : ''}
                    />    
                ))}
                
                {/* <ConclaveEventCard />
                <ConclaveEventCard />
                <ConclaveEventCard /> */}
                
            </div>: <NoDataContent message=" No preconclave events found under this sdg" />}
        </div>
    );
}